import { render } from "./examHistory.vue?vue&type=template&id=5432f94d"
import script from "./examHistory.vue?vue&type=script&lang=js"
export * from "./examHistory.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__